"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const lodash_1 = __importDefault(require("lodash"));
const prefix = `/api/ac/v2/service/management/apiKey/published`;
const API = {
    list: `${prefix}/list`,
    create: `${prefix}/create`,
    update: `${prefix}/update`,
    delete: `${prefix}/delete`,
};
class APIKey {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListAPIKey(serviceId, page = 0, limit = 10) {
        const query = {
            page,
            limit,
        };
        const url = `${API.list}?serviceId=${serviceId}&${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: 0,
            },
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.paging = resBody.paging;
        data.entities = resBody.entities;
        return data;
    }
    async createAPIKey(serviceId, payload) {
        const res = await this._httpClient.post(API.create, {
            serviceId,
            ...payload,
        });
        const resBody = lodash_1.default.get(res, 'data.data', {});
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateAPIKey(serviceId, apiKeyId, payload) {
        const res = await this._httpClient.put(`${API.update}?serviceId=${serviceId}&apiKeyId=${apiKeyId}`, payload);
        const resBody = lodash_1.default.get(res, 'data.data', {});
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async deleteAPIKey(serviceId, apiKeyId) {
        const url = `${API.delete}?serviceId=${serviceId}&apiKeyId=${apiKeyId}`;
        await this._httpClient.delete(url);
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = APIKey;
